
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.016 6.75H5.125a.625.625 0 110-1.25h15c.345 0 .625-.28.625-.625C20.75 3.839 19.91 3 18.875 3H4.5A2.5 2.5 0 002 5.5V18a2.5 2.5 0 002.5 2.5h15.516c1.094 0 1.984-.841 1.984-1.875v-10c0-1.034-.89-1.875-1.984-1.875zm-1.766 8.125a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z","fill":"#999"}})])
          )
        }
      }
    